import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, SmartphoneIcon, StarIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Bonus" className="border-y border-grape/10 bg-white/70" data-id="element-16" data-mp="avlbuhg5sxm9">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "22px"
    }} data-id="element-17" data-mp="fu6awdjodb94">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-18" data-mp="1un3jmyou3xv">
          🎁 Et vous recevez également 4 bonus
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm font-bold uppercase tracking-wide text-blush" data-id="element-19" data-mp="5xjrzuawsu9q">
          Offerts aujourd’hui seulement
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-20" data-mp="3szwoh07trs0m">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex gap-4 rounded-2xl border border-grape/20 bg-cream p-6" style={{
          paddingTop: "16px",
          paddingBottom: "16px"
        }} data-id="element-21" data-mp="1mai37xztfyws" data-mpi={i}>
              <img src={b.cover} alt={`Couverture du bonus ${b.title}`} width={1122} height={1402} loading="lazy" decoding="async" sizes="112px" className="h-auto w-24 shrink-0 self-start object-contain drop-shadow-[0_10px_18px_rgba(11,18,32,0.35)] sm:w-28" data-id="element-22" data-mp="3r68ev5ocl017" />
              <div className="flex min-w-0 flex-1 flex-col" data-id="element-23" data-mp="2uh0s5ubzskvp">
                <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-24" data-mp="2uikadqh7l604">
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-lilac-soft px-3 py-1 text-xs font-bold text-grape" data-id="element-25" data-mp="38hjzez8mvmwt">
                    <GiftIcon className="h-3.5 w-3.5" data-id="element-26" data-mp="np8denoybnmf" /> Bonus {b.n}
                  </span>
                  <span className="whitespace-nowrap text-sm font-bold" data-id="element-27" data-mp="irgbd0ulel4i">
                    <span className="text-plum/40 line-through" data-id="element-28" data-mp="itaz0mx90rca">{b.price}</span>{' '}
                    <span className="text-blush" data-id="element-29" data-mp="3cl0ryyrma2f7">OFFERT</span>
                  </span>
                </div>
                <h3 className="text-base font-bold text-plum" data-id="element-30" data-mp="3hju7sxudm5ij">{b.title}</h3>
                <p className="mt-1 text-sm font-semibold text-grape-deep" data-id="element-31" data-mp="3lke4k0b1f745">{b.tagline}</p>
                <p className="mt-2 text-sm leading-relaxed text-plum/65" data-id="element-32" data-mp="3qi5vaqzy4n6r">{b.desc}</p>
                <p className="mt-auto flex items-center gap-1.5 pt-3 text-xs font-semibold text-plum/55" data-id="element-33" data-mp="2ttgcmyghvqjq">
                  Valeur perçue :
                  <span className="flex gap-0.5 text-blush" aria-label="5 étoiles sur 5" data-id="element-34" data-mp="2xrxizfs3cx03">
                    {Array.from({
                  length: 5
                }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" data-id="element-35" data-mp="37kd3okurvzoo" data-mpi={k} />)}
                  </span>
                </p>
              </div>
            </motion.div>)}
        </div>

        <p className="mt-8 flex items-center justify-center gap-2 text-center text-sm font-semibold text-plum/60" data-id="element-36" data-mp="2f3ivv3kwa34k">
          <SmartphoneIcon className="h-4 w-4 shrink-0 text-grape" aria-hidden="true" data-id="element-37" data-mp="27jrkdx31ovzo" />
          📱 Utilisez votre système là où vous en avez besoin : ordinateur, tablette, smartphone.
        </p>

        <div className="mt-6 rounded-2xl border border-blush/30 bg-blush-soft p-6 text-center" style={{
        paddingTop: "11px",
        paddingBottom: "11px"
      }} data-id="element-38" data-mp="1xlk3fe8radxo">
          <p className="text-base font-bold text-plum sm:text-lg" data-id="element-39" data-mp="1tjyrbv41q3oj">
            💰 Valeur totale des bonus : <span className="text-plum/50 line-through" data-id="element-40" data-mp="1omgjk81rlui4">120 €</span>{' '}
            <span className="text-[15px] text-blush-deep" data-id="element-41" data-mp="1jtne1hyh2i4z">
              OFFERTS AUJOURD’HUI AVEC LE SYSTÈME COMPLET
            </span>
          </p>
        </div>
      </div>
    </section>;
}